module.exports = __webpack_public_path__ + "static/media/NK.e43ea3f5.png";